import {
  CategoryEntityStatus,
  FieldEntityStatus,
  RequestCandidateEntityStatus,
  RequestEntityStatus,
  TemplateTypeEntityStatus,
} from "generated";

export const getColorFieldStatus = (status: FieldEntityStatus) => {
  switch (status) {
    case FieldEntityStatus.Active:
      return "success";
    case FieldEntityStatus.InActive:
      return "error";
    default:
  }
};

export const getColorCategoryStatus = (status: CategoryEntityStatus) => {
  switch (status) {
    case CategoryEntityStatus.Active:
      return "success";
    case CategoryEntityStatus.InActive:
      return "error";
    default:
  }
};

export const getColorRequestEntityStatus = (status?: RequestEntityStatus) => {
  switch (status) {
    case RequestEntityStatus.Done:
      return "success";
    case RequestEntityStatus.InProgress:
      return "blue";
    case RequestEntityStatus.New:
      return "gray";
    case RequestEntityStatus.Rejected:
      return "error";
    case RequestEntityStatus.WaitingForApproval:
      return "primary";
    default:
  }
};

export const getColorRequestCandidateEntityStatus = (
  status: RequestCandidateEntityStatus
) => {
  switch (status) {
    // case RequestCandidateEntityStatus.Done:
    //   return "success";
    case RequestCandidateEntityStatus.Published:
      return "primary";
    case RequestCandidateEntityStatus.Cancelled:
      return "error";
    case RequestCandidateEntityStatus.InProgress:
      return "blue";
    default:
      return undefined;
  }
};

export const getColorTemplateTyeStatus = (status: TemplateTypeEntityStatus) => {
  switch (status) {
    case TemplateTypeEntityStatus.Active:
      return "success";
    case TemplateTypeEntityStatus.InActive:
      return "error";
    default:
  }
};


export const isJson = (string: string) => {
  try {
    JSON.parse(string)
  } catch (e) {
    return false
  }
  return true
}
